import apiClient from '../utils/apiClient';

/**
 * #102134 — Lịch sử gửi tin nhắn.
 *
 * Sếp hỏi *"xem lịch sử gửi tin nhắn đó ở đâu?"* — trước việc này không có chỗ nào. Bảng
 * `MessageLog` phía máy chủ CỐ Ý không lưu nội dung mật mã/OTP, nên API này không bao giờ trả
 * về nội dung tin; chỉ có loại tin, người nhận, trạng thái gửi và lý do lỗi.
 */
export const messageLogAPI = {
  getLogs: async (params = {}) =>
    apiClient.get({ url: '/message-logs', params }),

  getSummary: async (params = {}) =>
    apiClient.get({ url: '/message-logs/summary', params }),
};

export default messageLogAPI;
